module.exports = __webpack_public_path__ + "static/media/stopwatch.12d7131f.svg";